/* eslint-disable global-require */
const base = {
  qa: require("./qa/base"),
  staging: require("./staging/base"),
  production: require("./production/base")
};

export default base;
